<div class="row">
  <div class="col-12">
    <h2>{{ childName }}</h2>
    <h3>{{ "Change your child's data" | translate }}</h3>
  </div>
</div>
<app-partner-form [partner]='partner' [isChild]="true" (evntFormValid)="onChildFormValid()" (evntFormInvalid)="onChildFormInvalid()"></app-partner-form>
<div class="row">
  <div class="col-5">
    <app-button [title]="'Cancel' | translate" [buttonCssClass]="'group_button_2'" (click)="cancelClick()"></app-button>
  </div>
  <div class="col-2 justify-content-center">
    <app-button [buttonCssClass]="'group_button_3'" [iconCssClass]="'fa fa-trash'" (click)="deleteClick()" [disabled]="actionInProgress"></app-button>
  </div>
  <div class="col-5">
    <app-button [title]="'Save' | translate" [buttonCssClass]="'group_button_1'" (clickEvent)="saveClick()" [disabled]="!isSaveButtonEnabled"></app-button>
  </div>
</div>
